import Chart from "react-apexcharts";

const WinnerChart = ( props ) => {

	const options = {
		grid: {
			show: true,
			xaxis: {
				lines: {
					show: false
				}
			},
			yaxis: {
				lines: {
					show: false
				}
			},
		},
		dataLabels: {
			offsetY: 0,
			style: {
				fontSize: '24px',
				fontFamily: 'Helvetica, Arial, sans-serif',
				fontWeight: 'bold',
				colors: ['#5c4500', '#f3d3b9', '#01113d', '#430b0b', '#093800']
			},
		},
		tooltip: {
			enabled: false,
		},
		legend: {
			show: false,
		},
		theme: {
			mode: 'dark'
		},
		chart: {
			width: '100%',
			background: '#060606',
			toolbar: {
				show: false
			},
			id: "basic-bar"
		},
		plotOptions: {
			bar: {
				distributed: true,
				columnWidth: "90%",
			},
		},
		fill: {
			colors: ['#d4d04e', '#ff8924', '#008dce', '#ed2c47', '#21b400'],
		},
		xaxis: {
			categories: ["Aryans", "Mughals", "Rajputs", "Spartans", "Vikings"]
		},
		yaxis: {
			show: false
		},
		responsive: [{
			breakpoint: 1024,
			options: {
				dataLabels: {
					style: {
						fontSize: '14px',
					},
				},
			},
		}]
	}

	return (
		<div className="relative mx-auto w-full lg:w-4/6">
			<Chart
				options={options}
				series={[props.series]}
				type="bar"
			/>
		</div>
	);
};

export default WinnerChart;
